(function () {
  function clearClones(track) {
    track.querySelectorAll('[data-clone="true"]').forEach(function (node) {
      node.remove();
    });
  }

  function setupClones(track, realSlides) {
    clearClones(track);
    if (realSlides.length < 2) return;

    var first = realSlides[0].cloneNode(true);
    var last = realSlides[realSlides.length - 1].cloneNode(true);

    [first, last].forEach(function (clone) {
      clone.setAttribute('data-clone', 'true');
      clone.removeAttribute('data-feature-slide');
      clone.removeAttribute('id');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach(function (el) {
        el.removeAttribute('id');
      });
    });

    track.insertBefore(last, track.firstChild);
    track.appendChild(first);
  }

  function applyTrackTransform(track, translate, animate) {
    track.style.transition = animate === false ? 'none' : '';
    track.style.setProperty('--fc-translate', translate + 'px');
    track.style.transform = 'translate3d(' + translate + 'px, 0, 0)';

    if (animate === false) {
      void track.offsetHeight;
      requestAnimationFrame(function () {
        track.style.transition = '';
      });
    }
  }

  function getTranslate(viewport, track, slide, index, count, loop) {
    if (!viewport || !slide) return 0;

    if (!loop && index === 0) return 0;

    var centered = viewport.clientWidth / 2 - (slide.offsetLeft + slide.offsetWidth / 2);

    if (!loop && index === count - 1) {
      var minTranslate = viewport.clientWidth - track.scrollWidth;
      if (minTranslate > 0) minTranslate = 0;
      return Math.max(minTranslate, Math.min(0, centered));
    }

    return centered;
  }

  window.initFeatureCarousel = function (section, options) {
    if (!section) return;

    var host = section.querySelector('[data-feature-carousel]');
    if (!host) return;

    if (host._fcAbort) {
      host._fcAbort.abort();
      host._fcAbort = null;
    }

    var abort = new AbortController();
    host._fcAbort = abort;

    var viewport =
      host.querySelector('[data-feature-viewport]') ||
      host.querySelector('.feature-carousel__viewport');
    var track = host.querySelector('[data-feature-track]');
    if (!viewport || !track) return;

    track.querySelectorAll('[data-feature-spacer]').forEach(function (node) {
      node.remove();
    });

    var realSlides = Array.from(track.querySelectorAll('[data-feature-slide]'));
    var loop = host.hasAttribute('data-loop') && realSlides.length > 1;
    var animating = false;
    var index = 0;

    if (loop) {
      setupClones(track, realSlides);
    } else {
      clearClones(track);
    }

    function allSlides() {
      return Array.from(track.children);
    }

    function realStart() {
      return loop ? 1 : 0;
    }

    function realEnd() {
      return loop ? realSlides.length : realSlides.length - 1;
    }

    function updateNav() {
      host.querySelectorAll('[data-feature-prev]').forEach(function (btn) {
        btn.disabled = !loop && index <= realStart();
      });
      host.querySelectorAll('[data-feature-next]').forEach(function (btn) {
        btn.disabled = !loop && index >= realEnd();
      });
    }

    function updateClasses(activeIndex) {
      allSlides().forEach(function (slide, i) {
        var selected = i === activeIndex;
        slide.classList.toggle('is-selected', selected);
        slide.classList.toggle('is-before', i === activeIndex - 1);
        slide.classList.toggle('is-after', i === activeIndex + 1);
        slide.toggleAttribute('aria-hidden', !selected);
      });
    }

    function goTo(nextIndex, animate) {
      var slides = allSlides();
      var count = slides.length;
      if (!count) return;

      if (loop) {
        nextIndex = Math.max(0, Math.min(nextIndex, count - 1));
      } else {
        nextIndex = Math.max(0, Math.min(nextIndex, count - 1));
      }

      index = nextIndex;
      updateClasses(index);
      updateNav();
      void track.offsetHeight;

      var translate = getTranslate(viewport, track, slides[index], index, count, loop);
      applyTrackTransform(track, translate, animate);

      if (animate === false || !loop) {
        animating = false;
        return;
      }

      animating = true;
    }

    function snapFromClone() {
      if (!loop) return false;

      var slides = allSlides();
      var last = slides.length - 1;

      if (index === last) {
        goTo(realStart(), false);
        return true;
      }

      if (index === 0) {
        goTo(realEnd(), false);
        return true;
      }

      return false;
    }

    function onTransitionEnd(e) {
      if (e.target !== track) return;
      if (e.propertyName && e.propertyName !== 'transform') return;

      snapFromClone();
      animating = false;
    }

    track.addEventListener('transitionend', onTransitionEnd, { signal: abort.signal });

    function step(dir) {
      if (animating) return;

      var slides = allSlides();
      if (slides.length < 2) return;

      if (!loop) {
        var next = index + dir;
        if (next < 0 || next > slides.length - 1) return;
        goTo(next, true);
        return;
      }

      goTo(index + dir, true);

      var style = window.getComputedStyle(track);
      if (style.transitionDuration === '0s') {
        snapFromClone();
        animating = false;
      }
    }

    host.querySelectorAll('[data-feature-prev]').forEach(function (btn) {
      btn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          step(-1);
        },
        { signal: abort.signal }
      );
    });

    host.querySelectorAll('[data-feature-next]').forEach(function (btn) {
      btn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          step(1);
        },
        { signal: abort.signal }
      );
    });

    window.addEventListener(
      'resize',
      function () {
        goTo(index, false);
      },
      { passive: true, signal: abort.signal }
    );

    if (window.Shopify && Shopify.designMode) {
      host.addEventListener(
        'shopify:block:select',
        function (e) {
          var target = e.target;
          if (!target || target.hasAttribute('data-clone')) return;

          var currentReal = Array.from(track.querySelectorAll('[data-feature-slide]'));
          var i = currentReal.indexOf(target);
          if (i < 0) return;

          goTo(loop ? i + 1 : i, true);
        },
        { signal: abort.signal }
      );
    }

    host._fcGoTo = function (i, animate) {
      goTo(loop ? i + 1 : i, animate !== false);
    };

    goTo(realStart(), false);

    if (options && options.selectSlide) {
      var currentReal = Array.from(track.querySelectorAll('[data-feature-slide]'));
      var selectedIndex = currentReal.indexOf(options.selectSlide);
      if (selectedIndex > -1) goTo(loop ? selectedIndex + 1 : selectedIndex, true);
    }
  };

  document.addEventListener('shopify:section:load', function (e) {
    window.initFeatureCarousel(e.target);
  });
})();
